export default __webpack_public_path__ + "static/media/dark-infra-red.bfd583a9.svg";